import React from "react";
import { BG } from "../lib/brand";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative overflow-hidden bg-[#050505] py-24 sm:py-32"
    >
      <div className="kf-grain absolute inset-0 opacity-30" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-2xl">
          <div className="mb-3 text-xs uppercase tracking-[0.3em] text-[#E11D2A]">
            Our Story
          </div>
          <h2 className="font-display text-4xl tracking-widest text-[#F5F5DC] sm:text-5xl lg:text-6xl">
            Three Disciplines.
            <br />
            <span className="text-[#E11D2A]">One Dojo.</span>
          </h2>
          <p className="mt-6 text-base text-[#A1A1AA] sm:text-lg">
            We brew up a fierce mix of trading card games, table-top classics, and
            hand-shaken boba. Come for the singles, stay for the tournaments — and
            don&apos;t leave without a Dragon Milk Tea.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:grid-rows-2">
          {/* Cards — big tile */}
          <div
            className="group relative col-span-1 row-span-2 overflow-hidden border border-[#27272A]"
            data-testid="about-tile-cards"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
              style={{ backgroundImage: `url(${BG.tcgLifestyle})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" />
            <div className="relative flex h-full min-h-[420px] flex-col justify-end p-8">
              <div className="text-xs uppercase tracking-[0.3em] text-[#E11D2A]">01 · TCG</div>
              <h3 className="mt-2 font-display text-4xl tracking-widest text-[#F5F5DC] sm:text-5xl">
                Trading Cards
              </h3>
              <p className="mt-3 max-w-sm text-sm text-[#A1A1AA]">
                Pokémon, Magic, Yu-Gi-Oh!, One Piece — singles, sealed product
                and event-ready supplies.
              </p>
            </div>
          </div>

          {/* Board Games */}
          <div
            className="group relative overflow-hidden border border-[#27272A] bg-[#121212] p-8"
            data-testid="about-tile-board"
          >
            <div className="text-xs uppercase tracking-[0.3em] text-[#E11D2A]">02 · Tabletop</div>
            <h3 className="mt-2 font-display text-3xl tracking-widest text-[#F5F5DC]">
              Board Games
            </h3>
            <p className="mt-3 text-sm text-[#A1A1AA]">
              50+ titles to play in-store or take home. Catan to Wingspan, we got
              you.
            </p>
            <div className="mt-6 h-px bg-[#27272A]" />
            <div className="mt-4 text-xs uppercase tracking-widest text-[#A1A1AA]">
              Play-in-store available
            </div>
          </div>

          {/* Boba */}
          <div
            className="group relative overflow-hidden border border-[#27272A] bg-[#121212] p-8"
            data-testid="about-tile-boba"
          >
            <div className="text-xs uppercase tracking-[0.3em] text-[#E11D2A]">03 · Brew</div>
            <h3 className="mt-2 font-display text-3xl tracking-widest text-[#F5F5DC]">
              Boba Bar
            </h3>
            <p className="mt-3 text-sm text-[#A1A1AA]">
              House-brewed teas, fresh fruit blends and serious tapioca energy.
            </p>
            <div className="mt-6 h-px bg-[#27272A]" />
            <div className="mt-4 text-xs uppercase tracking-widest text-[#A1A1AA]">
              Daily 11AM – Close
            </div>
          </div>

          {/* Wide */}
          <div
            className="group relative col-span-2 overflow-hidden border border-[#27272A]"
            data-testid="about-tile-events"
          >
            <div
              className="absolute inset-0 bg-cover bg-center opacity-50 transition-transform duration-700 group-hover:scale-105"
              style={{ backgroundImage: `url(${BG.bobaLifestyle})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent" />
            <div className="relative flex h-full min-h-[200px] flex-col justify-center p-8">
              <div className="text-xs uppercase tracking-[0.3em] text-[#E11D2A]">
                Weekly Events
              </div>
              <h3 className="mt-2 font-display text-3xl tracking-widest text-[#F5F5DC] sm:text-4xl">
                Tournaments. Game Nights. Community.
              </h3>
              <p className="mt-2 max-w-xl text-sm text-[#A1A1AA]">
                From Friday Night One Piece to Sunday board game socials — find
                your crew here.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
